/**
 * メニューの通知の件数の印（下のメニュー・ホームと分類のページのカード・末端のメニューで共通）
 * 0 件なら何も出さない。className で置き場所（absolute など）を指定する
 */
const MenuBadge = ({ count, className = '' }) => {
  if (!count || count <= 0) return null;
  return (
    <span
      className={`min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold text-white bg-red-600 rounded-full ${className}`}
      aria-label={`新しい通知 ${count}件`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default MenuBadge;
